
export function fixedNumber(value: string|number, decimalPlaces: number): string {
    if(typeof(value) == "string")
        return parseFloat(value).toFixed(decimalPlaces);
    else
        return value.toFixed(decimalPlaces);
}
